import { render } from "./BasePage.vue?vue&type=template&id=e4c9b5de"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import "./BasePage.vue?vue&type=style&index=0&id=e4c9b5de&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__